import { render, staticRenderFns } from "./AddAboutUsProfile.vue?vue&type=template&id=028baef5&scoped=true&"
import script from "./AddAboutUsProfile.vue?vue&type=script&lang=js&"
export * from "./AddAboutUsProfile.vue?vue&type=script&lang=js&"
import style0 from "./AddAboutUsProfile.vue?vue&type=style&index=0&id=028baef5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028baef5",
  null
  
)

export default component.exports